import React, { useState, useEffect } from 'react';
import { PropTypes } from 'prop-types';
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from 'recharts';
import './plaza.scss';

const RADIAN = Math.PI / 180;

const renderCustomizedLabel = ({
  cx,
  cy,
  midAngle,
  innerRadius,
  outerRadius,
  value
}) => {
  const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
  const x = cx + radius * Math.cos(-midAngle * RADIAN);
  const y = cy + radius * Math.sin(-midAngle * RADIAN);
  return (
    <text
      x={x}
      y={y}
      fill='white'
      textAnchor='middle'
      dominantBaseline='central'
      fontSize='14px'
      fontWeight='bold'
      pointerEvents='none'
    >
      {value > 0.015 ? `${Math.round(100 * value)}%` : ''}
    </text>
  );
};

renderCustomizedLabel.propTypes = {
  cx: PropTypes.number.isRequired,
  cy: PropTypes.number.isRequired,
  midAngle: PropTypes.number.isRequired,
  innerRadius: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
  outerRadius: PropTypes.number.isRequired
};

const CustomTooltip = ({ active, payload }) => {
  return payload && payload[0] ? (
    <div
      className='custom-tooltip'
      style={{ borderLeft: `10px solid ${payload[0].payload.color}` }}
    >
      <p className='name' style={{ color: payload[0].payload.color }}>
        {payload[0].payload.name}
      </p>
      <p className='tweets_number'>Retwets: {payload[0].payload.rts}</p>
      <p className='tweets_number'>Favs: {payload[0].payload.favs}</p>
    </div>
  ) : (
    <text dominantBaseline='central' />
  );
};

CustomTooltip.propTypes = {
  active: PropTypes.bool,
  payload: PropTypes.arrayOf(PropTypes.shape({}))
};

CustomTooltip.defaultProps = {
  active: false,
  payload: []
};
let firstRender = true;
export const PlazaChart = ({ topics }) => {
  const [activeAnimation, setAnimation] = useState(false);
  useEffect(() => {
    if (!activeAnimation && topics.length) {
      if (!firstRender) {
        setAnimation(true);
      } else {
        firstRender = false;
      }
    }
  }, [topics]);
  return topics && topics.length > 0 ? (
    <ResponsiveContainer aspect={1} debounce={1}>
      <PieChart>
        <Tooltip content={<CustomTooltip />} />
        <Pie
          data={topics}
          innerRadius={'55%'}
          outerRadius={'100%'}
          paddingAngle={0}
          dataKey='percent'
          isAnimationActive={false}
          label={renderCustomizedLabel}
        >
          {topics.map((topic, index) => (
            <Cell key={topic.color} fill={topic.color} />
          ))}
        </Pie>
      </PieChart>
    </ResponsiveContainer>
  ) : (
    <div>loading</div>
  );
};

// PlazaChart.propTypes = {
//     party: PropTypes.any,
//     topics: PropTypes.arrayOf(PropTypes.any)
// };

export default PlazaChart;
